import React, { Component } from 'react';
import PropTypes from 'prop-types';
//import { withRouter } from 'react-router';
import { Auth } from 'aws-amplify';
import { AuthPiece } from 'aws-amplify-react';
import { Authenticator, Greetings, SignUp } from 'aws-amplify-react';
//import queryString from 'query-string';
import {
    LoginForm,
    RegisterForm,
    ConfirmRegisterForm,
    VerifyContactForm,
    ForgotPasswordForm
} from '../components';

export default class Start extends Component {

    constructor (props) {
        super(props)
        active_menu: 'home',
        //this.state = {session: 'signUp'}
        console.log('in Start constructor', this.props.location.state);
        this.handleChange = this.handleChange.bind(this)
     }

    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    }

    componentDidMount() {
        //console.log('in start with state values:',this.state)
        //console.log('in start with prop values:',this.props)
        //console.log('in start with props locations:',this.props.location)
        console.log('in Start didMount', this.props.location.state);
       //const values = queryString.parse(this.props.location.search)
       //console.log(values.id)
       //this.setState({ participantId: values.id });
       //this.setState({ leaderBoardName: values.name });
       // const {foo} = this.props.location.state
       // console.log('via props location state', foo)
      };

    handleChange (e) {
        this.setState({value: e.traget.value, dirty: true})
        e.preventDefault()
    }

    handleAuthStateChange (status) {
        console.log('thisistheAuthState', status)
    }

   // componentDidMount() {
      //Auth.signUp({
      //    username:'ellertonHere',
      //    password:'725$Wolfe',
      //    attributes: {
      //        email:'tom@daiware.io',
      //        phone_number:'+14436768702',
      //    },
      //    validationData: []
      //})
       // .then(data => console.log(data))
        //.catch(err => console.log(err));

      //Auth.confirmSignUp(username, code, {
       //   forceAliasCreation: true
      //}).then(data => console.log(data))
      //  .catch(err => console.log(err));


//      Auth.currentAuthenticatedUser()
 //       .then(user => console.log('user is in'))
  //      .catch(err => this.changeState('signUp'));
  //  }

    render() {
           const {
               participant_ID,
               match,
               location,
               history
           } = this.props
           return (
            <Authenticator hideDefault={true} authState={'signUp'} leaderboardName={'tryThis'} >
                <LoginForm priced={'oneDollar'} />
                <RegisterForm names={this.props.location.state} />
                <ConfirmRegisterForm />
                <VerifyContactForm />
                <ForgotPasswordForm />
            </Authenticator>
        ) 
    }
}



// WEBPACK FOOTER //
// ./src/modules/Start.jsx